module.exports = __webpack_public_path__ + "img/gb119.prt.88abe163.jpg";